/**
 * physicianRequests module route path constants.
 *
 * Mirrors `modules/claims/routes/routeConfig.ts`: both paths are declared here so App routing and
 * in-app navigation share one source of truth. `physicianRequestReviewPath` is the builder the
 * queue grid's row link uses to open a request on the review page.
 */
export const PHYSICIAN_REQUESTS_QUEUE_PATH = '/physician-requests';
export const PHYSICIAN_REQUESTS_REVIEW_PATH = '/physician-requests/:encounterId';
export const physicianRequestReviewPath = (encounterId: string): string => `/physician-requests/${encounterId}`;
